import Common from '../Common';
import Callers from './queue/Callers';
import Cdr from './queue/Cdr';
import Members from './queue/Members';
import Users from './queue/Users';

const Queue = class extends Common {
	members: InstanceType<typeof Members>;
	callers: InstanceType<typeof Callers>;
	cdr: InstanceType<typeof Cdr>;
	users: InstanceType<typeof Users>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.members = new Members(headers);
		this.callers = new Callers(headers);
		this.cdr = new Cdr(headers);
		this.users = new Users(headers);
	}

	async read(id: id) {
		return this.get(`/queue/${id}`);
	}
}

export default Queue
